import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router, RouterStateSnapshot, UrlTree } from "@angular/router";

import { Observable } from "rxjs";
import { isPlatformBrowser } from "@angular/common";
import { SharedService } from "../services/shared.service";
import { GlobalContants } from "../constants/global.contants";
import { StoreService } from "../services/store.service";

@Injectable(
    {providedIn: 'root'}
)

export class AuthGuard {

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private sharedService: SharedService,
        private storeService: StoreService,
        private router: Router
    ){}

    canActivate(
        state: RouterStateSnapshot
    ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if(isPlatformBrowser(this.platformId)){
        if (this.sharedService.getStoreValue(GlobalContants.StoreKey.userToken)) {
            return true;
        } else {
            this.storeService.clearAll();
            this.router.navigate(['/'])
            return false;
        }
    } else {
        return true;
    }
  }
}